import React, { useState } from 'react';
import RTTLive from './RTTLive';
import RTTHistory from './RTTHistory';
import '../assets/RemoteDebugSessionTabs.css';

/**
 * Real-Time Telemetry — second-level tab container.
 *
 * Uses the portal's custom sub-tab pattern (same as RealTimeDeviceManagement /
 * DeviceDiagnostics), NOT antd Tabs. Owns Live and History sub-tabs.
 */
function RealTimeTelemetry({ userInfo, role, userGroups = [] }) {
  const subTabs = [
    { key: 'Live', label: 'Live' },
    { key: 'History', label: 'History' },
  ];

  const [activeSubTab, setActiveSubTab] = useState('Live');

  const renderSubTabContent = () => {
    switch (activeSubTab) {
      case 'Live':
        return <RTTLive />;
      case 'History':
        return <RTTHistory />;
      default:
        return <RTTLive />;
    }
  };

  return (
    <div className="remote-debug-session-container">
      <div className="sub-tab-content">
        <div className="sub-tabs-container nested">
          {subTabs.map((tab) => (
            <div
              key={tab.key}
              className={`sub-tab ${activeSubTab === tab.key ? 'active' : ''}`}
              onClick={() => setActiveSubTab(tab.key)}
            >
              {tab.label}
            </div>
          ))}
        </div>
        {renderSubTabContent()}
      </div>
    </div>
  );
}

export default RealTimeTelemetry;
